export function fullNameInitialsFilter (fullName: string) {
  const array = fullName.trim().split(/\s+/);

  const firstLetter = array[0][0];
  const lastLetter = array[array.length - 1][0];

  return `${firstLetter}${lastLetter}`.toUpperCase();
}
